'use client';

import { useBrowserTelemetry } from '@frameio/telemetry';

export const BrowserTelemetry = () => {
  useBrowserTelemetry();
  return null;
};
